import { useDeviceInfo } from '@cian/ui-kit/responsive';
import { useToast } from '@cian/ui-kit/toast';
import * as React from 'react';
import { YmapsBlockedToastAction, YmapsBlockedToastContent } from 'shared/map-search/components/YmapsBlockedToast';

import { YMAPS_BLOCKED_TOAST_TEST_ID } from './constants';
import { useIsPortrait } from '../MapLayers/Features/NotFoundContainer/hooks';
import { getToastIndent } from '../MapLayers/Features/NotFoundContainer/utils';

/**
 * Показывает тост, если скрипт Яндекс карт подменил блокировщик (например, Анти-Баннер Касперского).
 * Менеджер загрузчика создаётся инлайн-скриптом ymapsLoader до запуска приложения
 */
export const YmapsBlockedToastContainer: React.FC = () => {
  const { isPhone, isTablet } = useDeviceInfo();
  const isPortrait = useIsPortrait();
  // Как у тоста пустой области: внизу по центру, на телефоне поднимаем над кнопкой «Список»
  const toast = useToast({
    placement: 'bottom-center',
    size: 'L',
    indent: getToastIndent({ isPhone, isTablet, isPortrait }),
  });

  React.useEffect(() => {
    let isActive = true;
    let toastId: string | null = null;

    window._cianYmapsLoaderManager?.getScriptLoadErrorReason().then(reason => {
      if (!isActive || reason !== 'stub') {
        return;
      }

      toastId = toast.open({
        type: 'error',
        dataTestId: YMAPS_BLOCKED_TOAST_TEST_ID,
        autoHide: false,
        hasCloseIcon: true,
        content: <YmapsBlockedToastContent />,
        rightAdornment: <YmapsBlockedToastAction onClick={() => window.location.reload()} />,
      });
    });

    return () => {
      isActive = false;

      if (toastId) {
        toast.hide(toastId);
      }
    };
  }, [toast]);

  return null;
};
